import { PAYMENT_SUCCESS, PAYMENT_ERROR, PAYMENT_PROCESSING, PAYMENT_RESET } from '../actions/deduction.action';
import { DeductionReducer } from '../models/deduction.interface';

const initialState: DeductionReducer = {
    paymentProcessing: false,
    paymentError: false,
    paymentSuccess: false,
}

const deductionReducer = (state: DeductionReducer = initialState, action: any): DeductionReducer => {

    switch (action.type) {
        case PAYMENT_PROCESSING:
            return {
                ...state,
                paymentProcessing: true,
            }
        case PAYMENT_SUCCESS:
            return {
                ...state,
                paymentProcessing: false,
                paymentSuccess: true
            }
        case PAYMENT_ERROR:
            return {
                ...state,
                paymentProcessing: false,
                paymentError: true,
            }
        case PAYMENT_RESET:
            return initialState
        default:
            return state;
    }
}

export default deductionReducer;